import React from 'react'
import { AuthProvider } from './authStore'
import { ModulosProvider } from './modulosStore'
import { QuestoesProvider } from './questoesStore'
import { QuestaoEditorProvider } from './questaoEditorStore'
import { UsuariosProvider } from './usuariosStore'
import { ForunsProvider } from './forunsStore'
import { CursosProvider } from './cursosStore'

export const StoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AuthProvider>
      <ModulosProvider>
        <QuestoesProvider>
          <QuestaoEditorProvider>
            <UsuariosProvider>
              <ForunsProvider>
                <CursosProvider>
                  {children}
                </CursosProvider>
              </ForunsProvider>
            </UsuariosProvider>
          </QuestaoEditorProvider>
        </QuestoesProvider>
      </ModulosProvider>
    </AuthProvider>
  )
}